import { render, staticRenderFns } from "./ReceivedInvoicesList.vue?vue&type=template&id=10140602&scoped=true"
import script from "./ReceivedInvoicesList.vue?vue&type=script&lang=js"
export * from "./ReceivedInvoicesList.vue?vue&type=script&lang=js"
import style0 from "./ReceivedInvoicesList.vue?vue&type=style&index=0&id=10140602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10140602",
  null
  
)

export default component.exports